import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter, Switch } from "react-router-dom";
import './index.css';
import AICatPrivacyPolicy from './screen/AICatPrivacy';
import AICatSupport from './screen/AICatSupport';
import Home from './screen/Home';
import PrivacyPolicy from './screen/privacy_policy'
import TermsOfService from './screen/terms_of_service'
import * as serviceWorker from './serviceWorker';
import AICatTermsOfUse from './screen/AICatTermsOfUse';
import EpochWechatID from './screen/EpochWechatID';

const App = () => (
  <BrowserRouter>
    <Switch>
      <Route
        exact
        path="/"
        render={() => (<Home />)}
      />
      <Route
        path="/privacy_policy"
        render={() => (<PrivacyPolicy />)}
      />
      <Route
        path="/terms_of_service"
        render={() => (<TermsOfService />)}
      />
      <Route
        path="/aicat_privacy"
        render={() => (<AICatPrivacyPolicy />)}
      />
      <Route
        path="/aicat_support"
        render={() => (<AICatSupport />)}
      />
      <Route
        path="/aicat_terms_of_use"
        render={() => (<AICatTermsOfUse />)}
      />
      <Route
        path="/epoch_wechat_id"
        render={() => (<EpochWechatID />)}
        />
    </Switch>
  </BrowserRouter>
)

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
